var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 22,
    viewBox: "0 0 15 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0814804 5.07554C0.0375117 4.49515 0.496573 4 1.07862 4H13.9214C14.5034 4 14.9625 4.49515 14.9185 5.07554L13.7064 21.0755C13.6669 21.597 13.2322 22 12.7093 22H2.29074C1.76776 22 1.33311 21.597 1.2936 21.0755L0.0814804 5.07554Z",
    fill: "#0084FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.75C0 1.19772 0.447715 0.75 1 0.75H3.83405C4.00256 0.75 4.16833 0.707421 4.31597 0.626216L5.22948 0.123784C5.37713 0.0425794 5.5429 0 5.7114 0H9.62951C9.79801 0 9.96378 0.0425793 10.1114 0.123784L11.0249 0.626216C11.1726 0.707421 11.3384 0.75 11.5069 0.75H14C14.5523 0.75 15 1.19772 15 1.75V2C15 2.55228 14.5523 3 14 3H1C0.447715 3 0 2.55228 0 2V1.75Z",
    fill: "#0084FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.6fedd9fbe204d4afce996883d5475de3.svg";
export { ForwardRef as ReactComponent };